export default "__VITE_ASSET__6414db08__"